import type { plannerRootEn } from './en.ts'

export const plannerRootRu: typeof plannerRootEn = {
  status: {
    loading: 'Загрузка доски…',
    liveSyncLost: (error: string) => `Связь с доской потеряна — изменения могут не сохраниться (${error})`,
    liveSyncLostAria: 'Связь с доской потеряна — изменения могут не сохраниться',
    viewOnly: 'Только просмотр — редактировать доску гильдии могут офицеры и владелец Discord-сервера.',
    oldRaidReadOnly: 'Завершённый рейд — редактировать его может только суперадминистратор.',
  },
  announcement: {
    sortedByRole: 'Все группы отсортированы по ролям',
    resetToSeed: 'Доска сброшена до начального состава',
    viewChanged: (mode: string) => `Режим отображения: ${mode}`,
    allStages: 'Показаны все этапы',
    stageSelected: (stageId: string) => `Показан этап ${stageId}`,
    stageAdded: (stage: string) => `Добавлен этап «${stage}»`,
    stageChangesReset: 'Изменения выбранного этапа сброшены',
    allStageChangesReset: 'Изменения всех этапов сброшены',
  },
  stageKind: {
    forest: 'Лес',
    towers: 'Башни',
    goose: 'Гусь',
    tree: 'Дерево',
    custom: 'Свой этап',
    opening: 'Начало',
  },
}
